import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ApiService } from './../../../services/api/api.service';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
@Component({
  selector: 'app-password-confirmation-dialog',
  templateUrl: './password-confirmation-dialog.component.html',
  styleUrls: ['./password-confirmation-dialog.component.css']
})
export class PasswordConfirmationDialogComponent {

  reset:any;
  hidePass = true;;
  @ViewChild('passwordInput') myInput!: ElementRef<HTMLInputElement>;

  constructor(
    public confirmDialog: MatDialog, private snackBar: MatSnackBar, private apiService: ApiService, public messageDialog:MatDialog, private dialogRef: MatDialogRef<PasswordConfirmationDialogComponent>){}

  formGroup: UntypedFormGroup;

  resetCheck: UntypedFormControl;

  snackBarDuration: number = 3000;

  submitBtnLabel: string = "Confirm";
  os:any="windows";
  errorMessage: any = null;

  ngOnInit() {
    // Initialize resetCheck in ngOnInit
    this.resetCheck = new UntypedFormControl(this.reset, Validators.required);

    this.resetCheck.valueChanges.subscribe(val => {
      this.reset = val;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.myInput.nativeElement.focus()); // delay ensures DOM is ready
  }

  OnSubmitClick(close: boolean) {
    this.errorMessage = null;
    if (this.resetCheck.invalid) {
      this.resetCheck.markAsTouched();

      this.snackBar.open("Invalid input detected, please try again.", "Close", {
        duration: this.snackBarDuration,
        panelClass: ['snackbar']
      });
      return;
    }

    
    // this.dialogRef.close(this.resetCheck.value);
    this.resetCheck.disable();
    
    this.apiService.Login(localStorage.getItem("Email"), this.resetCheck.value,this.os).subscribe(res => {
      // console.log(res);
      if (res?.error != null){
        this.confirmDialog.open(MessageDialogComponent, {
          data: 
          {
            message : res?.message, 
            // message: res.data[0].Exception
          }
        });
        this.resetCheck.enable();

      }
      else{
        // this.snackBar.open("Data reset successfully", "Close", {
        //   duration: this.snackBarDuration,
        //   panelClass: ['snackbar']
        // });

        this.dialogRef.close(true);

      }
    },
      (error) => {
        // console.log(error);
        this.errorMessage = error?.error?.message;
        // this.OnError(error, "Error Confirmation");
        this.resetCheck.enable();
      })
      
    // this.apiService.ResetData({ password: this.reset }).subscribe((data) => {
    //   if(data.success){
    //     this.snackBar.open("Data reset successfully", "Close", {
    //       duration: this.snackBarDuration,
    //       panelClass: ['snackbar']
    //     });

    //     this.dialogRef.close();
    //   }else{
    //     this.snackBar.open("Invalid Password", "Close", {
    //       duration: this.snackBarDuration,
    //       panelClass: ['snackbar']
    //     });
    //   }
    //   // this.dialogRef.close(true);
    // },
    //   (error) => {
    //     this.OnError(error, "Error reset");
    //     this.formGroup.enable();
    //   });
  }

  OnError(error: any, errorTitle: string) {
    let errMsg: string = "Error message(s) :\n";
    let errLength: number = Object.keys(error["error"]["data"]).length;
    let cols = Object.keys(error["error"]["data"]);

    if (errLength) {
      for (let i = 0; i < errLength; i++) {
        errMsg += error["error"]["data"][cols[i]];

        if (i != errLength - 1) {
          errMsg += "\n";
        }
      }
    }

    this.messageDialog.open(MessageDialogComponent, {
      data:
      {
        title: errorTitle,
        message: errMsg
      }
    });
  }

}
